import {fetchFluxBotAction} from "@/api/endpoints/fluxbot";


export async function createFluxBotTransfer({srcWallet, dstWallet, inAmount}: {
	srcWallet: string;
	dstWallet: string;
	inAmount: number;
}): Promise<any> {
	return await fetchFluxBotAction(srcWallet,"transfer", {
		source: srcWallet,
		dest: dstWallet,
		aToB: true,
		amount: inAmount
	});
}
